var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('section',{staticClass:"d-flex body-content",staticStyle:{"background-color":"#f1f3f4"}},[_c('h1',[_vm._v("Lobby Template 6")])])])}]

export { render, staticRenderFns }